var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowWarningTriangle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 52,
    viewBox: "0 0 60 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2906 4.4395C28.4484 2.45574 31.3149 2.45573 32.4726 4.4395L57.1299 46.6878C58.2971 48.6878 56.8545 51.2 54.5388 51.2H5.22443C2.90876 51.2 1.46619 48.6878 2.63342 46.6878L27.2906 4.4395Z",
    fill: "#F1C21B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3436 29.5529V22.4969H32.2916V29.5529L31.7036 36.3289H28.9316L28.3436 29.5529ZM28.2316 38.4569H32.4316V42.3769H28.2316V38.4569Z",
    fill: "#0D0F13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWarningTriangle);
export default __webpack_public_path__ + "static/media/yellow-warning-triangle.c60f18f221f90bc6e8f254c5b86d8053.svg";
export { ForwardRef as ReactComponent };